import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import {
  createCustomer,
  customerCategoryDropdown,
  customerStatusOption,
  customerStatusSelect,
  getMergedCustomerDropdown,
  GetVisitCustomerById,
  updateCustomerList,
} from "./customerData";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import { customerState, customerStateMange } from "./customerStateMange";
import { useLoading } from "../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import Swal from "sweetalert2";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import { productCodeOption } from "../salesOrder/salesOrderData/salesOrderData";
import { allUsers } from "../employee/employeeData";

const CustomerForm = () => {
  const [customerData, dispatch] = useReducer(
    customerStateMange,
    customerState
  );
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerOptionLoading, setCustomerOptionLoading] = useState(false);

  const [inputDisble, setInputDisble] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [employeeCodeOptions, setEmployeeCodeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const formType = location?.state?.type;

  const rowId = location?.state?.rowId;

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (rowId) {
      fetchById(rowId);
    }
  }, [rowId]);

  useEffect(() => {

    if (formType === "view") return;

    const fetchCustomerCategoryDropdown = async () => {
      try {
        const response = await request(BASEURL, customerCategoryDropdown);

        const responseData = response?.customerCategoryDropdown?.data;
        if (response?.customerCategoryDropdown?.success) {
          const optionValues = responseData?.map((item) => ({
            label: item?.customerCategory,
            value: item?.id,
          }));
          setCategoryOptions(optionValues);
        }
        else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: response?.customerCategoryDropdown?.message,
            showConfirmButton: true,
          })
        }
      } catch (error) {
        console.error("Error Fetching Customer Category Dropdown", error);
        Swal.fire({
          position: "top",
          icon: "error",
          title: error?.response?.errors?.[0]?.message,
          showConfirmButton: true,
        })
      }
    };

    fetchCustomerCategoryDropdown();
  }, [formType]);

  const fetchById = async (id) => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, GetVisitCustomerById, {
        id: id,
      });
      const success = res?.getCustomer?.success;
      const formValue = res?.getCustomer?.customers[0];
      if (success) {
        dispatch({
          value: { value: formValue?.customerCategory, label: formValue?.customerCategory },
          name: "customerCategory",
        });
        dispatch({
          value: {
            label: `${formValue?.customerName} (${formValue?.customerCode})`,
            code: formValue?.customerCode,
          },
          name: "selectCustomer",
        });

        dispatch({
          value:
            formValue?.salespersonvisitckoutSet[0]?.remarks || "No Remarks",
          name: "remarks",
        });
        dispatch({
          value: formValue?.customerCode,
          name: "customerCode",
        });
        dispatch({
          value: formValue?.customerName,
          name: "customerName",
        });
        dispatch({
          value: { value: formValue?.status, label: formValue?.status },
          name: "status",
        });
        dispatch({
          value: { value: formValue?.priceCode, label: formValue?.priceCode },
          name: "priceCode",
        });
        dispatch({
          value: {
            value: formValue?.customerStatus,
            label: formValue?.customerStatus,
          },
          name: "customerStatus",
        });
        const repCodeVal = formValue?.repCode || "";
        const repNameVal = formValue?.repName || "";
        const repLabel =
          repNameVal && repCodeVal
            ? `${repCodeVal} (${repNameVal})`
            : repCodeVal || repNameVal;

        dispatch({
          value: repNameVal,
          name: "repName",
        });
        dispatch({
          value: formValue?.creditlimit,
          name: "creditLimit",
        });
        dispatch({
          value: formValue?.balance,
          name: "Balance",
        });
        dispatch({
          value: formValue?.creditperiod,
          name: "creditPeriod",
        });
        dispatch({
          value: {
            value: repCodeVal,
            code: repCodeVal,
            label: repLabel,
            repName: repNameVal,
          },
          name: "repCode",
        });
      }
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchInitialData = async () => {
    setCustomerOptionLoading(true);
    setEmployeeLoading(true);

    try {
      const [customerResponse, employeeResponse] = await Promise.all([
        request(BASEURL, getMergedCustomerDropdown),
        request(BASEURL, allUsers),
      ]);

      const customerSuccess = customerResponse?.getMergedCustomerDropdown?.success;
      if (customerSuccess) {
        setCustomerOptions(
          customerResponse?.getMergedCustomerDropdown?.data || []
        );
      } else {
        setCustomerOptions([]);
      }

      const employeeData = employeeResponse?.allUsers || [];
      setEmployeeCodeOptions(employeeData);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setCustomerOptions([]);
      setEmployeeCodeOptions([]);
    } finally {
      setCustomerOptionLoading(false);
      setEmployeeLoading(false);
    }
  };

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      customerData.customerCategoryStatus === "success" &&
      customerData.customerCodeStatus === "success" &&
      customerData.customerNameStatus === "success" &&
      customerData.priceCodeStatus === "success" &&
      customerData.repNameStatus === "success" &&
      customerData.repCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const handleAddCustomer = async () => {
    const data = {
      user: userId,
      customerCategory: customerData?.customerCategory?.label,
      customerCode: customerData?.customerCode,
      customerName: customerData?.customerName,
      // status: customerData?.status?.label,
      priceCode: customerData?.priceCode?.label,
      repName: customerData?.repName,
      repCode:
        customerData?.repCode?.code ||
        customerData?.repCode?.value ||
        (typeof customerData?.repCode === "string"
          ? customerData.repCode
          : customerData?.repCode?.label),
      creditlimit: customerData?.creditLimit,
      creditperiod: customerData?.creditPeriod,
      balance: customerData?.Balance,
      customerStatus: customerData?.customerStatus?.value,
    };
    setCirleLoading(true);

    try {
      const res = await request(BASEURL, createCustomer, {
        input: data,
      });
      const success = res?.createCustomer?.success;
      const message = res?.createCustomer?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/visit-customer");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateCustomer = async () => {
    const data = {
      id: rowId,
      customerCategory: customerData?.customerCategory?.label,
      customerCode: customerData?.customerCode,
      customerName: customerData?.customerName,
      // status: customerData?.status?.label,
      priceCode: customerData?.priceCode?.label,
      repName: customerData?.repName,
      repCode:
        customerData?.repCode?.code ||
        customerData?.repCode?.value ||
        (typeof customerData?.repCode === "string"
          ? customerData.repCode
          : customerData?.repCode?.label),
      creditlimit: customerData?.creditLimit,
      creditperiod: customerData?.creditPeriod,
      balance: customerData?.Balance,
      customerStatus: customerData?.customerStatus?.value,
    };
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, updateCustomerList, {
        input: data,
      });

      const success = res?.updateCustomerList?.success;
      const message = res?.updateCustomerList?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/visit-customer");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleRepCodeChange = (e, s) => {
    if (e) {
      dispatch({ value: e?.repName || e?.employeeName || "", name: "repName" });
      dispatch({ value: e, name: s?.name || "repCode" });
    } else {
      dispatch({ value: "", name: "repName" });
      dispatch({ value: null, name: s?.name || "repCode" });
    }
  };

  const handleChangeCustomers = (e) => {
    if (e) {
      const data = customerOptions.find((item) => item.id === e.value);

      if (data) {
        dispatch({ value: data.customerCode, name: "customerCode" });
        dispatch({ value: data.customerName, name: "customerName" });
        dispatch({ value: { label: data.customerCategory, value: data?.customerCategory }, name: "customerCategory" });
        dispatch({ value: data.creditLimit, name: "creditLimit" });
        dispatch({ value: data.creditPeriod, name: "creditPeriod" });

        dispatch({
          value: { value: data.status, label: data.status },
          name: "customerStatus",
        });
      }
    } else {
      dispatch({ value: "", name: "customerCode" });
      dispatch({ value: "", name: "customerName" });
      dispatch({ value: "", name: "customerCategory" });
      dispatch({ value: "", name: "creditLimit" });
      dispatch({ value: "", name: "creditPeriod" });
      dispatch({ value: "", name: "customerStatus" });
    }

    dispatch({ value: e, name: "selectCustomer" });
  };

  const repCodeOptions =
    employeeCodeOptions
      ?.filter(
        (item) => item?.employeeCode && String(item.employeeCode).trim() !== ""
      )
      ?.map((item) => {
        const code = String(item.employeeCode).trim();
        const name = item?.employeeName ? String(item.employeeName).trim() : "";
        return {
          label: name ? `${code} (${name})` : code,
          value: code,
          code: code,
          repName: name,
          employeeName: name,
        };
      }) || [];

  const rawRepCode =
    customerData?.repCode?.code ||
    customerData?.repCode?.value ||
    (typeof customerData?.repCode === "string"
      ? customerData.repCode.trim()
      : "") ||
    "";

  const selectedRepCodeValue =
    rawRepCode
      ? repCodeOptions.find(
        (item) =>
          item.value === rawRepCode ||
          item.code === rawRepCode ||
          item.label === rawRepCode
      ) || {
        label: customerData?.repName
          ? `${rawRepCode} (${customerData.repName})`
          : customerData?.repCode?.label || String(rawRepCode),
        value: rawRepCode,
        code: rawRepCode,
        repName: customerData?.repName || "",
      }
      : customerData?.repCode?.label
        ? customerData.repCode
        : null;

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType === "add"
                    ? "Add Visit Customer Details"
                    : formType === "edit"
                      ? "Edit Visit Customer Details"
                      : "View Visit Customer Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />

        <CardContent sx={{ minHeight: "80vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Select Customer <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  value={customerData?.selectCustomer}
                  name="selectCustomer"
                  placeholder="Select Customer"
                  isDisabled={inputDisble}
                  multiline
                  rows={3}
                  isClearable
                  options={customerOptions?.map((item) => {
                    return {
                      value: item?.id,
                      label: `${item?.customerName} (${item?.customerCode})`,
                      code: item?.customerCode,
                    };
                  })}
                  onChange={(e) => handleChangeCustomers(e)}
                  isLoading={customerOptionLoading}
                  error={
                    customerData.selectCustomerStatus === "error" ? true : false
                  }
                  success={
                    customerData.selectCustomerStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="customerCode"
                  value={customerData?.customerCode}
                  placeholder="Enter Customer Name"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "customerCode" })
                  }
                  error={
                    customerData.customerCodeStatus === "error" ? true : false
                  }
                  success={
                    customerData.customerCodeStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="customerName"
                  value={customerData?.customerName}
                  placeholder="Enter Customer Name"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "customerName" })
                  }
                  error={
                    customerData.customerNameStatus === "error" ? true : false
                  }
                  success={
                    customerData.customerNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customerCategory"
                  value={customerData.customerCategory}
                  options={categoryOptions}
                  onChange={(e, s) => dispatch({ name: s.name, value: e })}
                  isClearable
                  isDisabled
                  error={customerData.customerCategoryStatus === "error"}
                  success={customerData.customerCategoryStatus === "success"}
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="customerStatus"
                  value={customerData?.customerStatus}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={customerStatusSelect?.map((item) => {
                    return {
                      value: item?.value,
                      label: item?.label,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  isClearable
                  error={
                    customerData.customerStatusStatus === "error" ? true : false
                  }
                  success={
                    customerData.customerStatusStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              {/* credit limit */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Credit Limit
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="creditLimit"
                  type="number"
                  value={customerData?.creditLimit}
                  placeholder="Enter CreditLimit"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "creditLimit" })
                  }
                  error={
                    customerData.creditLimitStatus === "error" ? true : false
                  }
                  success={
                    customerData.creditLimitStatus === "success" ? true : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>

              {/* credit Period */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Credit Period
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="creditPeriod"
                  type="number"
                  value={customerData?.creditPeriod}
                  placeholder="Enter CreditPeriod"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "creditPeriod" })
                  }
                  error={
                    customerData.creditPeriodStatus === "error" ? true : false
                  }
                  success={
                    customerData.creditPeriodStatus === "success" ? true : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Rep Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="repCode"
                  placeholder="Select Rep Code"
                  value={selectedRepCodeValue}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={repCodeOptions}
                  onChange={(e, s) => handleRepCodeChange(e, s)}
                  isClearable
                  error={customerData.repCodeStatus === "error" ? true : false}
                  success={
                    customerData.repCodeStatus === "success" ? true : false
                  }
                  isLoading={employeeLoading}
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Rep Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="repName"
                  placeholder="Enter Rep Name"
                  disabled={true}
                  value={customerData?.repName}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "repName" })
                  }
                  error={customerData.repNameStatus === "error" ? true : false}
                  success={
                    customerData.repNameStatus === "success" ? true : false
                  }
                />
              </Grid>

              {/* balance */}

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Balance
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="Balance"
                  type="number"
                  value={customerData?.Balance}
                  placeholder="Enter Balance"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "Balance" })
                  }
                  error={customerData.BalanceStatus === "error" ? true : false}
                  success={
                    customerData.BalanceStatus === "success" ? true : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>

              {/* customer status */}

              {formType != "add" && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Status <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="status"
                    value={customerData?.status}
                    customStyles={{ optionPadding: 20 }}
                    isDisabled={inputDisble}
                    options={customerStatusOption?.map((item) => {
                      return {
                        value: item,
                        label: item,
                      };
                    })}
                    onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                    isClearable
                    error={customerData.statusStatus === "error" ? true : false}
                    success={
                      customerData.statusStatus === "success" ? true : false
                    }
                  />
                </Grid>
              )}

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Price Code
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="priceCode"
                  value={customerData?.priceCode}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={productCodeOption?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e) => dispatch({ value: e, name: "priceCode" })}
                  error={
                    customerData.priceCodeStatus === "error" ? true : false
                  }
                  success={
                    customerData.priceCodeStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              {formType != "add" && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Remarks <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    multiline
                    rows={4}
                    name="remarks"
                    placeholder="Enter Remarks"
                    disabled={inputDisble}
                    value={customerData?.remarks}
                    onChange={(e) =>
                      dispatch({ value: e?.target?.value, name: "remarks" })
                    }
                    error={
                      customerData.remarksStatus === "error" ? true : false
                    }
                    success={
                      customerData.remarksStatus === "success" ? true : false
                    }
                  />
                </Grid>
              )}
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/visit-customer")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={
                  formType == "add" ? handleAddCustomer : handleUpdateCustomer
                }
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default CustomerForm;
